// src/components/pages/Pessoa/tabs/PessoaTabJuridica.jsx

import { Box, Typography } from '@mui/material';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import DataList from '../../../form/DataList';

import { retornaDataHora } from '../../../../utils/retornaDataFormatada';

export default function PessoaTabJuridica({ module, EnumRamoAtividade, EnumPJTipo }) {
    const { dados, socio, optionsSocio } = module.state;
    const { change } = module.actions;

    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">Informações de Pessoa Juridica</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Razão Social"
                    type="text"
                    name="pessoaJuridica.razaoSocial"
                    placeholder="Razão Social"
                    title="Razão Social da pessoa jurídica"
                    inputWidth="350px"
                    handleOnChange={change}
                    value={dados.razaoSocial || ''}
                />

                <Input
                    text="Nome Fantasia"
                    type="text"
                    name="pessoaJuridica.nomeFantasia"
                    placeholder="Nome Fantasia"
                    title="Nome Fantasia da pessoa jurídica"
                    inputWidth="350px"
                    handleOnChange={change}
                    value={dados.nomeFantasia || ''}
                />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Abertura"
                    type="date"
                    name="pessoaJuridica.abertura"
                    placeholder="Abertura"
                    title="Data de abertura da empresa"
                    handleOnChange={change}
                    value={dados.abertura || ''}
                />
                <Input
                    text="última atualização"
                    type="datetime-local"
                    name="pessoaJuridica.ultima_atualizacao"
                    title="Data da última atualização dos dados com a Receita Federal"
                    handleOnChange={change}
                    value={(dados.ultima_atualizacao && retornaDataHora(dados.ultima_atualizacao)) || ''}
                />
                <Select
                    name="pessoaJuridica.ramoAtividade"
                    text="Ramo de atividade"
                    options={EnumRamoAtividade}
                    handleOnChange={change}
                    value={dados.ramoAtividade || 'Industria'}
                    isEnum={true}
                />

                <Select
                    name="pessoaJuridica.tipo"
                    text="Tipo"
                    options={EnumPJTipo}
                    handleOnChange={change}
                    value={dados.tipo || 'MATRIZ'}
                    isEnum={true}
                />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <DataList
                    text="Sócio"
                    title="Selecione o sócio administrador"
                    name="pessoaJuridica.Socio"
                    inputWidth="350px"
                    filteredOptions={optionsSocio}
                    handleOnChange={change}
                    value={socio?.descricao || ''}
                />
            </Box>
        </Box>
    );
}
